import styled, { css } from 'styled-components';
import Logo from 'gatsby-theme-core/src/components/logo';

export default styled(Logo)`
  ${({ image }) => css`
    aspect-ratio: ${image.width} / ${image.height};
  `}

  display: block;
  max-height: 2.625rem;
  width: 100%;
`;
